import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

export class CompactView extends Component {
  renderListView() {
    const { zeroState, headerPane, filterPane, listPane } = this.props;
    return (
      <div id="listView">
        { headerPane }
        <div className="spacer tiny"></div>
        <div className="spacer small"></div>
        { filterPane || null }
        { listPane || zeroState }
      </div>
    );
  }

  renderDetailsView() {
    const { zeroState, backButtonLabel, detailsPane } = this.props;
    return (
    <div id="details">
      <div className="spacer tiny" />
      <div className="spacer small" />
      <button type="button" className="btn btn-primary" onClick={this.props.handleBackButtonClick}>
          <span className="glyphicon glyphicon-menu-left mobile-btn-icon" />
          <FormattedMessage { ...backButtonLabel } />
      </button>
      <div className="spacer tiny" />
      <div className="spacer small" />
      { detailsPane || zeroState }
    </div>);
  }

  render() {
    return (
      <div id="content">
        { this.props.isListView ? this.renderListView() : this.renderDetailsView() }
      </div>
    );
  }
}

CompactView.propTypes = {
  headerPane: PropTypes.object,
  filterPane: PropTypes.object,
  listPane: PropTypes.object,
  detailsPane: PropTypes.object,
  zeroState: PropTypes.object,
  backButtonLabel: PropTypes.object,
  handleBackButtonClick: PropTypes.func,
  isListView: PropTypes.bool,
};
